//#region src/lib/contest/contest.types.ts
/**
* Reasons a contest score event can carry. Stored as text in
* `contest_score_events.reason`; `*_cancel` reasons are the signed reversal of
* their positive counterpart and reference the same id.
*/
const CONTEST_SCORE_REASONS = [
	"referral_signup",
	"referral_signup_upline",
	"referee_app_install",
	"referee_first_purchase",
	"referee_first_sale",
	"referee_both",
	"referral_signup_cancel",
	"referral_signup_upline_cancel",
	"referee_first_purchase_cancel",
	"referee_first_sale_cancel",
	"referee_both_cancel",
	"manual_adjustment"
];
/** Narrows a stored `contest_score_events.reason` to a known reason. */
function isContestScoreReason(value) {
	return CONTEST_SCORE_REASONS.includes(value);
}
/** Award reasons a special event can target: every positive award except manual adjustments. */
const CONTEST_SCOPABLE_REASONS = [
	"referral_signup",
	"referral_signup_upline",
	"referee_app_install",
	"referee_first_purchase",
	"referee_first_sale",
	"referee_both"
];
/** True for an award reason a special event can target. */
function isScopableReason(reason) {
	return CONTEST_SCOPABLE_REASONS.includes(reason);
}
/** Reasons that can be reversed by an order cancellation or refund. */
const CONTEST_CONVERSION_REASONS = [
	"referee_first_purchase",
	"referee_first_sale",
	"referee_both"
];
/** Purchase and sale awards, the ones that convert a referee. */
const CONTEST_REFEREE_CONVERSION_REASONS = ["referee_first_purchase", "referee_first_sale"];
/** True for a purchase or sale award, the reasons that count a referee as converted. */
function isConversionReason(reason) {
	return CONTEST_REFEREE_CONVERSION_REASONS.includes(reason);
}
/** True for an award that a referee may only earn once per contest. */
function isContestConversionReason(reason) {
	return CONTEST_CONVERSION_REASONS.includes(reason);
}
/** Ledger reasons that decide whether a referee has a live conversion. */
const CONVERSION_LEDGER_REASONS = [
	"referee_first_purchase",
	"referee_first_sale",
	"referee_first_purchase_cancel",
	"referee_first_sale_cancel"
];
/** Maps a revocable reason to the reason used when it is reversed. */
const CONTEST_CANCEL_REASON = {
	referral_signup: "referral_signup_cancel",
	referral_signup_upline: "referral_signup_upline_cancel",
	referee_first_purchase: "referee_first_purchase_cancel",
	referee_first_sale: "referee_first_sale_cancel",
	referee_both: "referee_both_cancel"
};
/** Derived from the contest dates and its processing timestamps. */
const CONTEST_STATUSES = [
	"upcoming",
	"live",
	"ended"
];

//#endregion
export { CONTEST_CANCEL_REASON, CONTEST_CONVERSION_REASONS, CONTEST_REFEREE_CONVERSION_REASONS, CONTEST_SCOPABLE_REASONS, CONTEST_SCORE_REASONS, CONTEST_STATUSES, CONVERSION_LEDGER_REASONS, isContestConversionReason, isContestScoreReason, isConversionReason, isScopableReason };
//# sourceMappingURL=contest.types.js.map